import { InterfaceState } from './interface.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
    interfaceClearExports,
    interfaceDocumentClear,
    interfaceDocumentProcessing,
    interfaceDocumentReady,
    interfaceExportComplete,
    interfaceExportError,
    interfaceExportProgress,
    interfaceExportStart,
    interfaceSetExports,
    interfaceSetRouteData, interfaceSetSearchResults, interfaceSetSearchTerm,
    interfaceShipmentViewChanged
} from './interface.actions';
import { DocumentStateEnum } from '../../enum/document-state.enum';

const initialState: InterfaceState = {
    currentView: null,
    documentState: DocumentStateEnum.NONE,
    document: null,
    exporting: false,
    exportFormats: [],
    exportProvider: null,
    exportProgress: 0,
    routeData: {},
    searchTerm: null,
    searchActive: false,
    searchResults: []
};

const reducer = createReducer(
    initialState,
    on(interfaceShipmentViewChanged, (state, { id }) => ({ ...state, currentView: id })),
    on(interfaceDocumentClear, (state) => ({ ...state, documentState: DocumentStateEnum.NONE, documentUrl: null })),
    on(interfaceDocumentProcessing, (state) => ({ ...state, documentState: DocumentStateEnum.PROCESSING, documentUrl: null })),
    on(interfaceDocumentReady, (state, { document }) => ({ ...state, documentState: DocumentStateEnum.READY, document })),
    on(interfaceSetExports, (state, { formats, provider }) => ({ ...state, exportFormats: formats, exportProvider: provider })),
    on(interfaceClearExports, (state) => ({ ...state, exportFormats: [], exportProvider: null })),
    on(interfaceExportStart, (state) => ({ ...state, exporting: true })),
    on(interfaceExportComplete, (state) => ({ ...state, exporting: false })),
    on(interfaceExportError, (state) => ({ ...state, exporting: false })),
    on(interfaceExportProgress, (state, { progress }) => ({ ...state, exportProgress: progress })),
    on(interfaceSetRouteData, (state, { routeData }) => ({ ...state, routeData })),
    on(interfaceSetSearchTerm, (state, { term }) => ({ ...state, searchTerm: term, searchActive: !!term })),
    on(interfaceSetSearchResults, (state, { results }) => ( { ...state, searchResults: [ ...results ], searchActive: false }))
);

export function interfaceReducer(state: InterfaceState | undefined, action: Action): any {
    return reducer(state, action);
}
